import { useState } from "react";
import { Activity, CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, formatDate } from "@/lib/api";

const Row = ({ c }) => (
  <li className="flex items-start gap-3 rounded-xl border border-[#ececef] bg-white p-3" data-testid={`diag-row-${c.nome}`}>
    {c.ok ? <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-600" /> : <XCircle className="mt-0.5 h-5 w-5 shrink-0 text-red-600" />}
    <div className="min-w-0">
      <p className="text-sm font-semibold">{c.nome} <span className="font-normal text-[#71717a]">· {(c.ms / 1000).toFixed(1)}s</span></p>
      <p className="break-words text-xs text-[#52525b]">{c.dettaglio}</p>
    </div>
  </li>
);

export const AdminDiagnostics = ({ headers }) => {
  const [busy, setBusy] = useState(false);
  const [report, setReport] = useState(null);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/diagnostica", {}, { headers, timeout: 180000 });
      setReport(data ?? null);
    } catch (e) {
      toast.error(errMsg(e, "Controllo non riuscito. Riprova."));
    } finally {
      setBusy(false);
    }
  };

  const checks = Array.isArray(report?.controlli) ? report.controlli : [];
  const errors = Array.isArray(report?.ultimi_errori) ? report.ultimi_errori : [];

  return (
    <div className="card-soft mb-8 p-6 hover:translate-y-0" data-testid="admin-diagnostics">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="font-display flex items-center gap-2 text-lg font-bold"><Activity className="h-5 w-5 text-[#0066FF]" /> Diagnostica video</p>
          <p className="mt-1 text-sm text-[#52525b]">Prova ogni pezzo della creazione video su questo server e mostra il motivo degli ultimi errori.</p>
        </div>
        <button onClick={run} disabled={busy} className="btn-blu h-11 px-5 text-sm" data-testid="run-diagnostics-button">
          {busy ? <><Loader2 className="h-4 w-4 animate-spin" /> Controllo in corso...</> : "Esegui controllo"}
        </button>
      </div>
      {report && (
        <div className="mt-5 space-y-4">
          <p className="rounded-xl bg-[#F5F5F7] p-3 text-xs text-[#3f3f46]" data-testid="diag-system">{report.sistema}</p>
          <ul className="grid gap-2 md:grid-cols-2">{checks.map((c) => <Row key={c.nome} c={c} />)}</ul>
          <div>
            <p className="text-sm font-semibold">Ultimi video non riusciti</p>
            {errors.length === 0 ? (
              <p className="mt-1 text-sm text-[#52525b]">Nessun errore registrato.</p>
            ) : (
              <ul className="mt-2 space-y-2" data-testid="diag-errors">
                {errors.map((e) => (
                  <li key={e.id} className="rounded-xl border border-red-100 bg-red-50 p-3 text-xs text-red-900">
                    <span className="font-semibold">{formatDate(e.created_at)} · {e.idea}</span>
                    <span className="mt-1 block break-words">{e.errore_tecnico || "motivo non registrato (video creato prima dell'aggiornamento)"}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
